// 'use client'

// import { CircleCheckBig, File, LoaderCircle, X } from 'lucide-react'
// import Image from 'next/image'
// import Link from 'next/link'

// import { bffUrl } from '@/helpers/urls'
// import { validateDeclarationAction } from '@/actions/declaracao/validate-declaration-action'
// import {
//   AlertDialog,
//   AlertDialogCancel,
//   AlertDialogContent,
//   AlertDialogHeader,
//   AlertDialogTitle,
//   AlertDialogTrigger,
// } from '@/components/ui/alert-dialog'
// import { Button } from '@/components/ui/button'
// import {
//   Dialog,
//   DialogClose,
//   DialogContent,
//   DialogHeader,
//   DialogTitle,
// } from '@/components/ui/dialog'
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from '@/components/ui/form'
// import { Input } from '@/components/ui/input'
// import { Label } from '@/components/ui/label'
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from '@/components/ui/select'
// import { bff_client } from '@/lib/apiClient'
// import warningImg from '@/public/img/warning.svg'
// import { zodResolver } from '@hookform/resolvers/zod'
// import CryptoJS from 'crypto-js'
// import { set } from 'date-fns'
// import { use, useEffect, useState } from 'react'
// import { useForm } from 'react-hook-form'
// import { toast } from 'sonner'
// import { z } from 'zod'

// interface Product {
//   id: string
//   name: string
// }

// interface User {
//   id: string
//   full_name: string
//   preferred_name: string | null
//   document_number: string
//   email: string
//   phone_number: string
// }

// interface ValidateDocument {
//   id: string
//   object: string
//   status: string
//   document_url: string
//   document_copy_url: string
//   enrolment_id: string
//   exam_score: string
//   product: Product
//   user: User
// }

// interface CheckCertificateModalProps {
//   code: string
//   onClose: () => void
// }

// const checkCertificateSchema = z.object({
//   code: z.string().min(1, 'Campo obrigatório'),
//   solicitorType: z
//     .string()
//     .nonempty({ message: 'Informe quem está solicitando' }),
//   institutionName: z.string().min(1, 'Informe o nome da instituição'),
//   institutionCnpj: z.string().optional(),
// })

// type CheckCertificateType = z.infer<typeof checkCertificateSchema>

// export default function CheckCertificateModal({
//   code,
//   onClose,
// }: CheckCertificateModalProps) {
//   const [isLoading, setIsLoading] = useState(false)
//   const [isValid, setIsValid] = useState<boolean | null>(null)
//   const [validateInfo, setValidateInfo] = useState<ValidateDocument | null>(
//     null
//   )
//   const [md5IdValidation, setMd5IdValidation] = useState('')

//   const form = useForm<CheckCertificateType>({
//     resolver: zodResolver(checkCertificateSchema),
//     defaultValues: {
//       code: '',
//       solicitorType: '',
//       institutionCnpj: '',
//       institutionName: '',
//     },
//   })

//   async function onSubmit(data: CheckCertificateType) {
//     console.log({ data })
//     setIsLoading(true)
//     try {
//       const result = await validateDeclarationAction({
//         code: data.code,
//       })

//       console.log('🚀 ~ startTransition ~ result:', result)
//       if (!result.ok) {
//         // toast.error('Código inválido.')
//         setIsValid(false)
//         return
//       }

//       setValidateInfo(result.data.object)
//       const hashMD5 = CryptoJS.MD5(result.data.object.id).toString(
//         CryptoJS.enc.Hex
//       )
//       setMd5IdValidation(hashMD5)
//       setIsValid(true)
//       // toast.success('Código válido.')
//     } catch (error) {
//       console.error('Form submission error', error)
//       // toast.error('Código inválido')
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   useEffect(() => {
//     if (code) {
//       setIsValid(null)
//       form.setValue('code', code)
//     }
//   }, [code, form])

//   const solicitorType = form.watch('solicitorType')

//   if (isValid) {
//     return (
//       <Dialog open={!!code} onOpenChange={onClose}>
//         <DialogContent className="max-w-90 rounded-xl px-6 font-rethink md:max-w-133.5">
//           <DialogHeader className="flex flex-row items-center justify-between space-y-0">
//             <DialogTitle className="text-lg font-medium text-[#2E2E2E]">
//               Consultar Certificado
//             </DialogTitle>
//           </DialogHeader>

//           <div className="mt-3">
//             <div className="flex items-center gap-4 rounded-md bg-[#D0FFE1] p-2">
//               <CircleCheckBig className="text-green-700" />
//               <div>
//                 <span className="text-2xl font-medium uppercase text-green-500">
//                   VÁLIDO
//                 </span>
//               </div>
//             </div>
//             <ul className="text-gray-600 font-semibold text-sm space-y-1.5 mt-2">
//               <li>
//                 Aluno:{' '}
//                 <span className="text-zinc-900 font-normal">
//                   {validateInfo?.user.full_name}
//                 </span>
//               </li>
//               <li>
//                 Curso:{' '}
//                 <span className="text-zinc-900 font-normal">
//                   {validateInfo?.product.name}
//                 </span>
//               </li>
//               <li>
//                 Nota de aprovação:{' '}
//                 <span className="text-zinc-900 font-normal">
//                   {validateInfo?.exam_score}
//                 </span>
//               </li>
//               {validateInfo?.document_copy_url && (
//                 <li className="flex items-center gap-1">
//                   Cópia do certificado:{' '}
//                   <Link
//                     target="_blank"
//                     href={validateInfo?.document_copy_url}
//                     className="flex items-center p-1 rounded hover:bg-slate-500/15 text-gray-500"
//                   >
//                     <File className="size-3.5" />
//                     Visualizar Cópia
//                   </Link>
//                 </li>
//               )}
//             </ul>

//             <div className="md:px-6 py-3 text-center border-y border-gray-400 border-collapse mt-4 border-dashed">
//               <span className="text-gray-400">
//                 Registro eletrônico: {md5IdValidation}
//               </span>
//             </div>

//             <p className="text-sm text-gray-600 italic">
//               Certificado emitido em conformidade com as leis e diretrizes
//               Brasileiras de Educação a Distância, Decreto Federal nº 5.154/2004
//               e Resolução CNE nº 04/99 – MEC (art. 7º, § 3º)
//             </p>

//             {/* <div className="mt-5 flex items-center gap-4 rounded bg-[#D0FFE1] p-6">
//                   <CircleCheckBig className="text-green-700" />
//                   <div>
//                     <span className="text-2.5xl font-medium uppercase text-green-500">
//                       VÁLIDO
//                     </span>
//                     <p className="text-sm font-normal text-[#656566]">
//                       Código informado pertence a nossa base de dados.
//                     </p>
//                   </div>
//                 </div> */}
//           </div>
//         </DialogContent>
//       </Dialog>
//     )
//   }

//   return (
//     <AlertDialog open={!!code} onOpenChange={onClose}>
//       {/* <AlertDialogTrigger asChild>{children}</AlertDialogTrigger> */}

//       <AlertDialogContent className="max-w-90 rounded-xl px-6 font-rethink md:max-w-133.5">
//         <AlertDialogHeader className="flex flex-row items-center justify-between space-y-0">
//           <AlertDialogTitle className="text-lg font-medium text-[#2E2E2E]">
//             Consultar Certificado
//           </AlertDialogTitle>
//           <AlertDialogCancel>
//             <span className="flex items-center gap-2 rounded-full bg-[#131313] px-2 text-sm font-normal text-[#F8F9FA]">
//               Fechar <X className="size-4" />
//             </span>
//           </AlertDialogCancel>
//         </AlertDialogHeader>

//         <Form {...form}>
//           <form onSubmit={form.handleSubmit(onSubmit)}>
//             <div className="mt-6 space-y-4">
//               <FormField
//                 control={form.control}
//                 name="code"
//                 render={({ field }) => (
//                   <FormItem>
//                     <FormControl>
//                       <div>
//                         <FormLabel
//                           htmlFor="code"
//                           className="z-10 ml-3.5 bg-white px-1 text-xs font-medium text-[#656566]"
//                         >
//                           Informe o código de autenticidade no campo abaixo
//                         </FormLabel>
//                         <Input
//                           id="code"
//                           disabled={isLoading}
//                           placeholder="Código de autenticidade"
//                           className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
//                           {...field}
//                         />
//                       </div>
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <FormField
//                 control={form.control}
//                 name="solicitorType"
//                 render={({ field }) => (
//                   <FormItem className="space-y-0">
//                     <FormLabel className="text-base text-[#525252]">
//                       Quem está solicitando a autenticação?
//                     </FormLabel>
//                     <Select
//                       onValueChange={field.onChange}
//                       defaultValue={field.value}
//                       value={field.value}
//                     >
//                       <FormControl>
//                         <SelectTrigger className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]">
//                           <SelectValue placeholder="Quem está solicitando é...." />
//                         </SelectTrigger>
//                       </FormControl>
//                       <SelectContent>
//                         <SelectItem value="1">Aluno</SelectItem>
//                         <SelectItem value="2">Cartório</SelectItem>
//                         <SelectItem value="3">Departamento Público</SelectItem>
//                         <SelectItem value="4">Instituição Privada</SelectItem>
//                       </SelectContent>
//                     </Select>
//                     <FormMessage className="text-xs" />
//                   </FormItem>
//                 )}
//               />

//               {(solicitorType === '2' ||
//                 solicitorType === '3' ||
//                 solicitorType === '4') && (
//                 <>
//                   <FormField
//                     control={form.control}
//                     name="institutionName"
//                     render={({ field }) => (
//                       <FormItem>
//                         <FormControl>
//                           <div>
//                             <FormLabel
//                               htmlFor="code"
//                               className="z-10 ml-3.5 bg-white px-1 text-xs font-medium text-[#656566]"
//                             >
//                               Nome da Instituição Solicitante *
//                             </FormLabel>
//                             <Input
//                               id="code"
//                               disabled={isLoading}
//                               placeholder="Nome"
//                               className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
//                               {...field}
//                             />
//                           </div>
//                         </FormControl>
//                         <FormMessage />
//                       </FormItem>
//                     )}
//                   />

//                   <FormField
//                     control={form.control}
//                     name="institutionCnpj"
//                     render={({ field }) => (
//                       <FormItem>
//                         <FormControl>
//                           <div>
//                             <FormLabel
//                               htmlFor="code"
//                               className="z-10 ml-3.5 bg-white px-1 text-xs font-medium text-[#656566]"
//                             >
//                               CNPJ da instituição Solicitante
//                             </FormLabel>
//                             <Input
//                               id="code"
//                               disabled={isLoading}
//                               placeholder="CNPJ"
//                               className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
//                               {...field}
//                             />
//                           </div>
//                         </FormControl>
//                         <FormMessage />
//                       </FormItem>
//                     )}
//                   />
//                 </>
//               )}

//               {/* <div>
//                 <Label
//                   htmlFor="email"
//                   className="text-sm font-normal text-[#656566]"
//                 >
//                   Quem está solicitando a autenticação?
//                 </Label>
//                 <Input
//                   id="email"
//                   type="email"
//                   placeholder="Código de autenticidade "
//                   className="mt-2 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
//                 />
//               </div> */}
//             </div>

//             {/* {isValid && (
//               <div className="mt-3">
//                 <div className="flex items-center gap-4 rounded-md bg-[#D0FFE1] p-2">
//                   <CircleCheckBig className="text-green-700" />
//                   <div>
//                     <span className="text-2xl font-medium uppercase text-green-500">
//                       VÁLIDO
//                     </span>
//                   </div>
//                 </div>
//                 <ul className="text-gray-600 font-semibold text-sm space-y-1.5 mt-2">
//                   <li>
//                     Aluno:{' '}
//                     <span className="text-zinc-900 font-normal">
//                       {validateInfo?.user.full_name}
//                     </span>
//                   </li>
//                   <li>
//                     Curso:{' '}
//                     <span className="text-zinc-900 font-normal">
//                       {validateInfo?.product.name}
//                     </span>
//                   </li>
//                   <li>
//                     Nota de aprovação:{' '}
//                     <span className="text-zinc-900 font-normal">
//                       {validateInfo?.exam_score}
//                     </span>
//                   </li>
//                   {validateInfo?.document_copy_url && (
//                     <li className="flex items-center gap-1">
//                       Cópia do certificado:{' '}
//                       <Link
//                         target="_blank"
//                         href={validateInfo?.document_copy_url}
//                         className="flex items-center p-1 rounded hover:bg-slate-500/15 text-gray-500"
//                       >
//                         <File className="size-3.5" />
//                         Visualizar Cópia
//                       </Link>
//                     </li>
//                   )}
//                 </ul>

//                 <div className="md:px-6 py-3 text-center border-y border-gray-400 border-collapse mt-4 border-dashed">
//                   <span className="text-gray-400">
//                     Registro eletrônico: {md5IdValidation}
//                   </span>
//                 </div>

//                 <p className="text-sm text-gray-600 italic">
//                   Certificado emitido em conformidade com as leis e diretrizes
//                   Brasileiras de Educação a Distância, Decreto Federal nº
//                   5.154/2004 e Resolução CNE nº 04/99 – MEC (art. 7º, § 3º)
//                 </p>

//                  <div className="mt-5 flex items-center gap-4 rounded bg-[#D0FFE1] p-6">
//                   <CircleCheckBig className="text-green-700" />
//                   <div>
//                     <span className="text-2.5xl font-medium uppercase text-green-500">
//                       VÁLIDO
//                     </span>
//                     <p className="text-sm font-normal text-[#656566]">
//                       Código informado pertence a nossa base de dados.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )} */}

//             {/* {isValid === false && (
//               <div className="mt-5 flex items-center gap-4 rounded bg-[#FFEBD0] p-6">
//                 <Image
//                   src={warningImg}
//                   alt="Imagem de aviso"
//                   width={48}
//                   height={48}
//                 />
//                 <div>
//                   <span className="text-2.5xl font-medium uppercase text-[#2E2E2E]">
//                     INVÁLIDO
//                   </span>
//                   <p className="text-sm font-normal text-[#656566]">
//                     Código informado não pertence a nossa base de dados.
//                   </p>
//                 </div>
//               </div>
//             )} */}

//             <div className="mt-5 w-full">
//               <div className="flex flex-col gap-x-1 leading-none md:flex-row">
//                 <span className="text-sm font-normal text-[#ABACAD]">
//                   Enfrentando problemas?
//                 </span>
//                 <Link href="#" className="text-sm text-[#5973F1] underline">
//                   Falar com nosso suporte.
//                 </Link>
//               </div>
//               <div className="mt-4 flex justify-end">
//                 <Button
//                   type="submit"
//                   disabled={isLoading}
//                   className="h-10 max-w-44.5 text-sm"
//                 >
//                   {isLoading ? (
//                     <LoaderCircle className="size-8 text-white animate-spin" />
//                   ) : (
//                     'Verificar Autenticidade'
//                   )}
//                 </Button>
//               </div>
//             </div>
//           </form>
//         </Form>
//       </AlertDialogContent>
//     </AlertDialog>
//   )
// }

'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import CryptoJS from 'crypto-js'
import { CircleCheckBig, File, LoaderCircle, X } from 'lucide-react'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { validateDeclarationAction } from '@/actions/declaracao/validate-declaration-action'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useMask } from '@/hooks/use-mask'

interface Product {
  id: string
  name: string
}

interface User {
  id: string
  full_name: string
  preferred_name: string | null
  document_number: string
  email: string
  phone_number: string
}

interface ValidateDocument {
  id: string
  object: string
  status: string
  document_url: string
  document_copy_url: string
  enrolment_id: string
  exam_score: string
  product: Product
  user: User
}

interface CheckCertificateModalProps {
  code: string
  onClose: () => void
}

const createCheckCertificateSchema = (solicitorType: string) => {
  const baseSchema = z.object({
    code: z.string().min(1, 'Campo obrigatório'),
    solicitorType: z
      .string()
      .nonempty({ message: 'Informe quem está solicitando' }),
  })

  if (solicitorType === 'Aluno' || !solicitorType) {
    return baseSchema.extend({
      institutionName: z.string().optional(),
      institutionCnpj: z.string().optional(),
    })
  }

  return baseSchema.extend({
    institutionName: z.string().min(1, 'Informe o nome da instituição'),
    institutionCnpj: z.string().optional(),
  })
}

type CheckCertificateType = z.infer<
  ReturnType<typeof createCheckCertificateSchema>
>

export function CheckCertificateModal({
  code,
  onClose,
}: CheckCertificateModalProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [isValid, setIsValid] = useState<boolean | null>(null)
  const [validateInfo, setValidateInfo] = useState<ValidateDocument | null>(
    null
  )
  const [md5IdValidation, setMd5IdValidation] = useState('')
  const [solicitorType, setSolicitorType] = useState('')

  const { getFieldProps } = useMask({ type: 'cnpj' })

  const currentSchema = createCheckCertificateSchema(solicitorType)

  const form = useForm<CheckCertificateType>({
    resolver: zodResolver(currentSchema),
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      code: '',
      solicitorType: '',
      institutionCnpj: '',
      institutionName: '',
    },
  })

  function resetForm() {
    form.reset(
      {
        code: '',
        solicitorType: '',
        institutionName: '',
        institutionCnpj: '',
      },
      { keepErrors: false }
    )
    setSolicitorType('')
    setIsValid(null)
    setValidateInfo(null)
    setMd5IdValidation('')
  }

  useEffect(() => {
    const subscription = form.watch((value, { name }) => {
      if (name === 'solicitorType' && value.solicitorType !== solicitorType) {
        setSolicitorType(value.solicitorType || '')

        if (value.solicitorType === 'Aluno') {
          form.setValue('institutionName', '', { shouldValidate: false })
          form.setValue('institutionCnpj', '', { shouldValidate: false })
          form.clearErrors('institutionName')
          form.clearErrors('institutionCnpj')
        }
      }
    })

    return () => subscription.unsubscribe()
  }, [form, solicitorType])

  useEffect(() => {
    const newSchema = createCheckCertificateSchema(solicitorType)
    // Só limpa erros se houver erros
    const hasErrors = Object.keys(form.formState.errors).length > 0
    if (hasErrors) {
      form.clearErrors()
    }
  }, [solicitorType, form])

  async function onSubmit(data: CheckCertificateType) {
    setIsLoading(true)
    try {
      const result = await validateDeclarationAction({
        code: data.code,
        maderDocumentNumber: data.institutionCnpj ?? '',
        maderName: data.institutionName ?? '',
        maderType: data.solicitorType ?? '',
      })

      if (!result.ok) {
        setIsValid(false)
        return
      }

      setValidateInfo(result.data.object)
      const hashMD5 = CryptoJS.MD5(result.data.object.id).toString(
        CryptoJS.enc.Hex
      )
      setMd5IdValidation(hashMD5)
      setIsValid(true)
    } catch (error) {
      console.error('Form submission error', error)
      setIsValid(false)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (code) {
      setIsValid(null)
      form.clearErrors()
      form.setValue('code', code, { shouldValidate: false })
    } else {
      // Se não há código, reseta o formulário
      resetForm()
    }
  }, [code, form])

  const currentSolicitorType = form.watch('solicitorType')

  if (isValid) {
    return (
      <Dialog onOpenChange={onClose} open={!!code}>
        <DialogContent className="max-w-90 rounded-xl px-6 font-rethink md:max-w-133.5">
          <DialogHeader className="flex flex-row items-center justify-between space-y-0">
            <DialogTitle className="font-medium text-[#2E2E2E] text-lg">
              Consultar Certificado
            </DialogTitle>
          </DialogHeader>

          <div className="mt-3">
            <div className="flex items-center gap-4 rounded-md bg-[#D0FFE1] p-2">
              <CircleCheckBig className="text-green-700" />
              <div>
                <span className="font-medium text-2xl text-green-500 uppercase">
                  VÁLIDO
                </span>
              </div>
            </div>
            <ul className="mt-2 space-y-1.5 font-semibold text-gray-600 text-sm">
              <li>
                Aluno:{' '}
                <span className="font-normal text-zinc-900">
                  {validateInfo?.user.full_name}
                </span>
              </li>
              <li>
                Curso:{' '}
                <span className="font-normal text-zinc-900">
                  {validateInfo?.product.name}
                </span>
              </li>
              <li>
                Nota de aprovação:{' '}
                <span className="font-normal text-zinc-900">
                  {validateInfo?.exam_score}
                </span>
              </li>
              {validateInfo?.document_copy_url && (
                <li className="flex items-center gap-1">
                  Cópia do certificado:{' '}
                  <Link
                    className="flex items-center rounded p-1 text-gray-500 hover:bg-slate-500/15"
                    href={validateInfo?.document_copy_url}
                    target="_blank"
                  >
                    <File className="size-3.5" />
                    Visualizar Cópia
                  </Link>
                </li>
              )}
            </ul>

            <div className="mt-4 border-collapse border-gray-400 border-y border-dashed py-3 text-center md:px-6">
              <span className="text-gray-400">
                Registro eletrônico: {md5IdValidation}
              </span>
            </div>

            <p className="text-gray-600 text-sm italic">
              Certificado emitido em conformidade com as leis e diretrizes
              Brasileiras de Educação a Distância, Decreto Federal nº 5.154/2004
              e Resolução CNE nº 04/99 – MEC (art. 7º, § 3º)
            </p>
          </div>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <AlertDialog onOpenChange={onClose} open={!!code}>
      <AlertDialogContent className="max-w-90 rounded-xl px-6 font-rethink md:max-w-133.5">
        <AlertDialogHeader className="flex flex-row items-center justify-between space-y-0">
          <AlertDialogTitle className="font-medium text-[#2E2E2E] text-lg">
            Consultar Certificado
          </AlertDialogTitle>
          <AlertDialogCancel>
            <span className="flex items-center gap-2 rounded-full bg-[#131313] px-2 font-normal text-[#F8F9FA] text-sm">
              Fechar <X className="size-4" />
            </span>
          </AlertDialogCancel>
        </AlertDialogHeader>

        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="mt-6 space-y-4">
              <FormField
                control={form.control}
                name="code"
                render={({ field }) => (
                  <FormItem>
                    <FormControl>
                      <div>
                        <FormLabel
                          className="z-10 ml-3.5 bg-white px-1 font-medium text-[#656566] text-xs"
                          htmlFor="code"
                        >
                          Informe o código de autenticidade no campo abaixo
                        </FormLabel>
                        <Input
                          className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
                          disabled={isLoading}
                          id="code"
                          placeholder="Código de autenticidade"
                          {...field}
                        />
                      </div>
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="solicitorType"
                render={({ field }) => (
                  <FormItem className="space-y-0">
                    <FormLabel className="text-[#525252] text-base">
                      Quem está solicitando a autenticação?
                    </FormLabel>
                    <Select
                      defaultValue={field.value}
                      onValueChange={field.onChange}
                      value={field.value}
                    >
                      <FormControl>
                        <SelectTrigger className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]">
                          <SelectValue placeholder="Quem está solicitando é...." />
                        </SelectTrigger>
                      </FormControl>
                      <SelectContent>
                        <SelectItem value="Aluno">Aluno</SelectItem>
                        <SelectItem value="Cartório">Cartório</SelectItem>
                        <SelectItem value="Departamento Público">
                          Departamento Público
                        </SelectItem>
                        <SelectItem value="Instituição Privada">
                          Instituição Privada
                        </SelectItem>
                      </SelectContent>
                    </Select>
                    <FormMessage className="text-xs" />
                  </FormItem>
                )}
              />

              {(currentSolicitorType === 'Cartório' ||
                currentSolicitorType === 'Departamento Público' ||
                currentSolicitorType === 'Instituição Privada') && (
                <>
                  <FormField
                    control={form.control}
                    name="institutionName"
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          <div>
                            <FormLabel
                              className="z-10 ml-3.5 bg-white px-1 font-medium text-[#656566] text-xs"
                              htmlFor="institutionName"
                            >
                              Nome da Instituição Solicitante *
                            </FormLabel>
                            <Input
                              className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
                              disabled={isLoading}
                              id="institutionName"
                              placeholder="Nome"
                              {...field}
                            />
                          </div>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    name="institutionCnpj"
                    render={({ field }) => (
                      <FormItem>
                        <FormControl>
                          <div>
                            <FormLabel
                              className="z-10 ml-3.5 bg-white px-1 font-medium text-[#656566] text-xs"
                              htmlFor="institutionCnpj"
                            >
                              CNPJ da instituição Solicitante
                            </FormLabel>
                            <Input
                              className="-mt-2.5 h-12 rounded border border-[#D7D7D9] bg-transparent bg-white text-sm placeholder:text-[#ABACAD]"
                              disabled={isLoading}
                              id="institutionCnpj"
                              placeholder="CNPJ"
                              {...getFieldProps(field)}
                            />
                          </div>
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </>
              )}
            </div>

            <div className="mt-5 w-full">
              <div className="flex flex-col gap-x-1 leading-none md:flex-row">
                <span className="font-normal text-[#ABACAD] text-sm">
                  Enfrentando problemas?
                </span>
                <Link
                  className="text-[#5973F1] text-sm underline"
                  href="/ajuda"
                >
                  Falar com nosso suporte.
                </Link>
              </div>
              <div className="mt-4 flex justify-end">
                <Button
                  className="h-10 max-w-44.5 text-sm"
                  disabled={isLoading}
                  type="submit"
                >
                  {isLoading ? (
                    <LoaderCircle className="size-8 animate-spin text-white" />
                  ) : (
                    'Verificar Autenticidade'
                  )}
                </Button>
              </div>
            </div>
          </form>
        </Form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
